import {
	type TypedUseSelectorHook,
	useDispatch,
	useSelector,
} from 'react-redux'
import type { AppDispatch, RootState, ThunkAppDispatch } from 'src/redux/store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppThunkDispatch = () => useDispatch<ThunkAppDispatch>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
